import { Details, Credit } from './ImageCaption.Styles';

export interface ImageCaptionProps {
  caption?: string;
  credit?: string;
  className?: string;
}

const ImageCaption = ({ caption, credit, className }: ImageCaptionProps) => (
  <Details className={className}>
    {caption && <div>{caption}</div>}
    {credit && <Credit>{credit}</Credit>}
  </Details>
);

export default ImageCaption;
